import { PUBLIC_RENTAL_GROUP_ID } from '@apeiron/orbital'
import RentalEditRow from '@src/components/orbitalTrack/rentalSetting/common/RentalEditRow'
import { RentalType } from '@src/components/orbitalTrack/rentalSetting/common/RentalSettingDialog'
import { FC } from 'react'

const PublicRentalEdit: FC = () => {
  return (
    <RentalEditRow
      rentalType={RentalType.PUBLIC}
      defaultExpanded
      groupId={PUBLIC_RENTAL_GROUP_ID}
    />
  )
}

export default PublicRentalEdit
